module.exports = __webpack_public_path__ + "img/org_logo.809f1d1b.jpg";